import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ITochiAsset } from "@snackpass/snackpass-types";
import { StoreState } from ".";
import { ITochiChickenAsset } from "../types";

export const getAssets = (state: StoreState) => state.tochiAsset;

export type TochiAssetReduxType = {
  chicken: ITochiChickenAsset;
  egg: ITochiAsset;
} | null;

const tochiAssetSlice = createSlice({
  name: "tochiAsset",
  initialState: null as TochiAssetReduxType,
  reducers: {
    setAssets: (
      state: TochiAssetReduxType,
      action: PayloadAction<TochiAssetReduxType>
    ) => {
      state = action.payload;
      return state;
    },
  },
});

export const { setAssets } = tochiAssetSlice.actions;
export const tochiAssetReducer = tochiAssetSlice.reducer;
